import { render, staticRenderFns } from "./OrderSummary.vue?vue&type=template&id=a4a1baf4&"
import script from "./OrderSummary.vue?vue&type=script&lang=ts&"
export * from "./OrderSummary.vue?vue&type=script&lang=ts&"
import style0 from "./OrderSummary.vue?vue&type=style&index=0&id=a4a1baf4&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports